import React, { useEffect, useState } from "react";
import { Box, SimpleGrid } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import General from "views/admin/profile/components/General";
import ProfileCard from "./component/ProfileCard";
import SubscriptionTable from "./component/SubscriptionTable";
import { Row, Col } from "antd";
import { Controller } from "Controller/Controller";
import TransactionTable from "./component/TransactionTable";
import MemberVisitTable from "./component/MemberVisitTable";
import { Button as AntdButton, Input, Modal } from "antd";
import { Alert } from "components/Alert/Alert";
import MemberTreatmentTable from "./component/MemberTreatmentTable";
import MemberCardsCarousel from "./component/MemberCardsCarousel";
import MemberRewardTable from "./component/MemberRewardTable";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const visitTableColumnsTopCreators = [
  {
    Header: "Member",
    accessor: "member",
  },
  {
    Header: "Service",
    accessor: "service_name",
  },
  {
    Header: "Count",
    accessor: "count",
  },
  {
    Header: "Date",
    accessor: "date",
  },
];
const treatmentTableColumnsTopCreators = [
  {
    Header: "Service",
    accessor: "service_name",
  },
  {
    Header: "Used",
    accessor: "used",
  },
  {
    Header: "Remaining",
    accessor: "avilable",
  },
  {
    Header: "Detail",
    accessor: "expiration_date",
  },
];

const tableColumnsTopCreators = [
  {
    Header: " Plan",
    accessor: "plan_name",
  },
  {
    Header: "Start",
    accessor: "start_date",
  },
  {
    Header: "Expire",
    accessor: "expiration_date",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Action",
    accessor: "action",
  },
];

const transactionTableColumnsTopCreators = [
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Date",
    accessor: "created",
  },
  {
    Header: "Currency",
    accessor: "currency",
  },
  {
    Header: "Description",
    accessor: "decription",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Action",
    accessor: "Action",
  },
];

const ViewSubscription = ({ row, changeCurrentStateToshowSubscription }) => {
  return (
    <p
      style={{ color: "#0981C8" }}
      onClick={() => {
        changeCurrentStateToshowSubscription(row);
      }}
    >
      View
    </p>
  );
};

const BusinessMemberDetail = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  // state
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [subscriptionPagination, setSubscriptionPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [transactionPagination, setTransactionPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [visitPagination, setVisitPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [subscriptionRows, setSubscriptionRows] = useState([
    {
      id: "",
      plan_name: "",
      start_date: "",
      expiration_date: "",
      status: "",
    },
  ]);
  const [transactionRows, setTransactionRows] = useState([
    {
      id: "",
      amount: "",
      created: "",
      currency: "",
      decription: "",
      status: "",
    },
  ]);

  const [memberProfile, setMemberProfile] = useState({
    business_name: "",
    first_name: "",
    middle_name: null,
    last_name: "",
    address: "",
    city: "",
    state: "",
    email: null,
    phone: null,
    zip_code: null,
    profile_picture: "",
    contact_person: {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
    },
  });

  const [basicEditValues, setBasicEditValues] = useState({
    business_name: "",
    first_name: "",
    middle_name: null,
    last_name: "",
    address: "",
    city: "",
    state: "",
    email: null,
    phone: null,
    zip_code: null,
    profile_picture: "",
    contact_person: {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
    },
  });

  const [loadingCreate, setLoadingCreate] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [visits, setVisits] = useState([]);
  const [treatments, setTreatments] = useState([]);
  // MemberCardsCarousel
  const [memberCards, setMemberCards] = useState([
    {
      id: "pm_test_visa",
      brand: "visa",
      last4: "4242",
      exp_month: 4,
      exp_year: 2032,
      name: "-",
      isDefault: true,
    },
    {
      id: "pm_test_mc",
      brand: "mastercard",
      last4: "4444",
      exp_month: 10,
      exp_year: 2030,
      name: "-",
      isDefault: false,
    },
    {
      id: "pm_test_amex",
      brand: "amex",
      last4: "0005",
      exp_month: 12,
      exp_year: 2034,
      name: "-",
      isDefault: false,
    },
  ]);

  // functions

  const handleCloseEditMember = async () => {
    setOpenModalEdit(false);
    setBasicEditValues({
      business_name: "",
      first_name: "",
      middle_name: null,
      last_name: "",
      address: "",
      city: "",
      state: "",
      email: null,
      phone: null,
      zip_code: null,
      profile_picture: "",
      contact_person: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
      },
    });
  };

  const handleChangeEdit = (e) => {
    const { name, value } = e.target;
    if (name.includes("contact_person.")) {
      const field = name.split(".")[1];
      setBasicEditValues((prev) => ({
        ...prev,
        contact_person: {
          ...prev.contact_person,
          [field]: value,
        },
      }));
    } else {
      setBasicEditValues({
        ...basicEditValues,
        [name]: value,
      });
    }
  };

  const handleEditMember = async () => {
    setLoadingCreate(true);
    const temp = {
      ...basicEditValues,
    };

    delete temp.customer_plan;
    delete temp.profile_picture;
    delete temp.id;

    const url = window.location.href;
    const parts = url.split("/");
    const id = parts.pop();

    const response = await Controller.editBusinessMember(temp, id);
    if (response.status < 250) {
      Alert.openNotification(
        response.message ? response.message : "Successful",
        "success"
      );

      setMemberProfile((prevProfile) => ({
        ...prevProfile,
        ...temp,
      }));

      setOpenModalEdit(false);
      setBasicEditValues({
        business_name: "",
        first_name: "",
        middle_name: null,
        last_name: "",
        address: "",
        city: "",
        state: "",
        email: null,
        phone: null,
        zip_code: null,
        profile_picture: "",
        id: -1,
        contact_person: {
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
        },
      });
    } else {
      Alert.openNotification(
        response.detail ? (Array.isArray(response.detail) ? response.detail[0] : response.detail) : "Error",
        "error"
      );
    }
    setLoadingCreate(false);
  };

  const handleAvatarChange = async (file) => {
    try {
      const url = window.location.href;
      const parts = url.split("/");
      const id = parts.pop();

      const formData = new FormData();
      formData.append("profile_picture", file);

      const response = await Controller.editMemberProfilePicture(formData, id);

      if (response.status < 250) {
        if (response.profile_picture) {
          setMemberProfile((prevProfile) => ({
            ...prevProfile,
            profile_picture: response.profile_picture,
          }));
        } else {
          await getSubscriptionData(subscriptionPagination.current);
        }

        Alert.openNotification(
          response.message ? response.message : "Profile picture updated",
          "success"
        );
        return true;
      }

      const errorMessage =
        response.detail?.[0] ||
        response.message ||
        response.profile_picture?.[0] ||
        "Error";

      Alert.openNotification(errorMessage, "error");
      return false;
    } catch (error) {
      Alert.openNotification("Error uploading profile picture", "error");
      return false;
    }
  };

  const changeCurrentStateToshowSubscription = () => {
    console.log("hi");
  };

  const getVisitData = async (page = 1) => {
    const url = window.location.href;
    const parts = url.split("/");
    const id = parts.pop();

    const response = await Controller.GetMemberVisits(
      id,
      page,
      visitPagination.pageSize
    );

    if (response.status < 250) {
      var temp = [];
      for (var i in response.json.results) {
        temp.push(response.json.results[i]);
      }
      console.log(temp);
      setVisits(temp);

      // Update pagination state
      setVisitPagination((prev) => ({
        ...prev,
        current: page,
        total: response.json.count || 0,
      }));
    }
  };

  useEffect(() => {
    getVisitData();
  }, []);

  const updateTreatmentData = () => {
    getTreatmentData();
  };
  const getTreatmentData = async () => {
    const url = window.location.href;
    const parts = url.split("/");
    const id = parts.pop();

    const response = await Controller.GetMemberTreatments(id);
    if (response.status < 250) {
      var temp = [];
      for (var i in response.json) {
        temp.push(response.json[i]);
      }
      console.log(temp);
      setTreatments(temp);
    }
  };

  useEffect(() => {
    getTreatmentData();
  }, []);

  const getSubscriptionData = async (page = 1) => {
    const url = window.location.href;
    const parts = url.split("/");
    const id = parts.pop();

    const response = await Controller.readBusinessMemberDetail(id);
    const responseSubscriptions = await Controller.GetSubscriptions(
      id,
      page,
      subscriptionPagination.pageSize
    );

    var tempSub = [];

    for (var i in responseSubscriptions.json.results) {
      var temp = {
        key: i,
        name: responseSubscriptions.json.results[i].plan_name,
        start: responseSubscriptions.json.results[i].start_date,
        exp: responseSubscriptions.json.results[i].expiration_date,
        status: responseSubscriptions.json.results[i].status,
        action: (
          <ViewSubscription
            row={responseSubscriptions.json.results[i]}
            changeCurrentStateToshowSubscription={
              changeCurrentStateToshowSubscription
            }
          />
        ),
      };
      tempSub.push(temp);
    }

    setMemberProfile(response.json);
    setSubscriptionRows(responseSubscriptions.json.results);

    // Update pagination state
    setSubscriptionPagination((prev) => ({
      ...prev,
      current: page,
      total: responseSubscriptions.json.count || 0,
    }));
  };

  // Update the getTransactionData function
  const getTransactionData = async (page = 1) => {
    const url = window.location.href;
    const parts = url.split("/");
    const id = parts.pop();

    const responseTransactions = await Controller.GetMemberTransactions(
      id,
      page,
      transactionPagination.pageSize
    );

    if (
      !responseTransactions.json.results ||
      responseTransactions.json.results.length === 0
    ) {
      console.log("No transactions available.");
      setTransactionRows([]);
      setTransactionPagination((prev) => ({
        ...prev,
        total: 0,
      }));
      return;
    }

    var tempSub = [];

    for (var i in responseTransactions.json.results) {
      var temp = {
        key: i,
        amount: responseTransactions.json.results[i].amount,
        date: responseTransactions.json.results[i].created,
        currency: responseTransactions.json.results[i].currency,
        description: responseTransactions.json.results[i].description,
        status: responseTransactions.json.results[i].status,
      };
      tempSub.push(temp);
    }

    setTransactionRows(responseTransactions.json.results);

    // Update pagination state
    setTransactionPagination((prev) => ({
      ...prev,
      current: page,
      total: responseTransactions.json.count || 0,
    }));
  };

  const getMemberCards = async () => {
    // try {
    //   const url = window.location.href;
    //   const id = url.split("/").pop();
    //   const res = await Controller.GetMemberCards(id);
    //   ...
    // } catch (e) {
    //   console.warn("getMemberCards() error:", e);
    // }

    // === MOCK DATA (already in your code) ===
    setMemberCards([
      {
        id: "pm_test_visa",
        brand: "visa",
        last4: "4242",
        exp_month: 4,
        exp_year: 2032,
        name: "-",
        isDefault: true,
      },
      {
        id: "pm_test_mc",
        brand: "mastercard",
        last4: "4444",
        exp_month: 10,
        exp_year: 2030,
        name: "-",
        isDefault: false,
      },
      {
        id: "pm_test_amex",
        brand: "amex",
        last4: "0005",
        exp_month: 12,
        exp_year: 2034,
        name: "-",
        isDefault: false,
      },
    ]);
  };

  const handleAddCardClick = async () => {
    // TODO:
    // 1) const { client_secret } = await Controller.CreateMemberSetupIntent(memberId)
    // 2) Modal با <Elements><PaymentElement/></Elements>
    // 3) await stripe.confirmSetup({ elements, clientSecret, redirect: 'if_required' })
    // 4) await getMemberCards()
    console.log("Add Card clicked (stub)");
  };

  const handleRemoveCard = async (pmId) => {
    // try {
    //   await Controller.DetachPaymentMethod(pmId); //  501
    // } finally {
    //   await getMemberCards();
    // }
    console.log("salam");
  };

  const handleMakeDefault = async (pmId) => {
    // try {
    //   const url = window.location.href;
    //   const id = url.split("/").pop();
    //   await Controller.SetDefaultPaymentMethod(id, pmId); //  501
    // } finally {
    //   await getMemberCards();
    // }
    console.log("bye");
  };

  const updateData = () => {
    getSubscriptionData(
      subscriptionPagination.current,
      subscriptionPagination.pageSize
    );
  };
  const updateTransactionData = () => {
    getTransactionData(transactionPagination.current);
  };
  const updateVisitData = () => {
    getVisitData(visitPagination.current);
  };
  useEffect(() => {
    getSubscriptionData();
    getTransactionData();
    getMemberCards();
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const url = window.location.href;
  const parts = url.split("/");
  const id = parts.pop();
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid>
        <Row type="flex" justify={"space-between"} gutter={[32]}>
          <Col span={10}>
            <Row>
              <ProfileCard
                data={memberProfile}
                onAvatarChange={handleAvatarChange}
                onEditClick={() => {
                  setBasicEditValues(memberProfile);
                  setOpenModalEdit(true);
                }}
              />
            </Row>

            {/* === NEW SECTION: Member Rewards === */}
            <Card mt="20px">
              <div style={{ width: "100%" }}>
                <MemberRewardTable memberId={id} />
              </div>
            </Card>
            <Card px="0px" mb="20px" mt="20px">
              <MemberVisitTable
                updateData={updateVisitData}
                tableData={visits}
                columnsData={visitTableColumnsTopCreators}
                pagination={visitPagination}
                handlePaginationChange={(page) => {
                  getVisitData(page);
                }}
              />
            </Card>
            <Card px="0px" mb="20px" mt="20px">
              <MemberTreatmentTable
                updateData={updateTreatmentData}
                tableData={treatments}
                columnsData={treatmentTableColumnsTopCreators}
              />
            </Card>
          </Col>
          <Col span={14}>
            <Row>
              <Col style={{ width: "100%" }}>
                <Card>
                  <div style={{ width: "100%" }}>
                    <SubscriptionTable
                      updateData={updateData}
                      tableData={subscriptionRows}
                      columnsData={tableColumnsTopCreators}
                      handleUpdateList={getSubscriptionData}
                      pagination={subscriptionPagination}
                      handlePaginationChange={(page) => {
                        getSubscriptionData(page);
                      }}
                    />
                  </div>
                </Card>
              </Col>
              <br />
              <br />
              <Col style={{ width: "100%", marginTop: "20px" }}>
                <Card>
                  <div style={{ width: "100%" }}>
                    <TransactionTable
                      updateData={updateTransactionData}
                      tableData={transactionRows}
                      columnsData={transactionTableColumnsTopCreators}
                      handleUpdateList={getTransactionData}
                      pagination={transactionPagination}
                      handlePaginationChange={(page) => {
                        getTransactionData(page);
                      }}
                      memberId={id}
                    />
                  </div>
                </Card>
              </Col>

              {/* === NEW SECTION: Member Cards Carousel*/}
              <Col style={{ width: "100%", marginTop: "20px" }}>
                <Card>
                  <MemberCardsCarousel
                    title="Member Cards"
                    loading={false}
                    cards={memberCards}
                    onAddClick={handleAddCardClick}
                    onRemove={handleRemoveCard}
                    onMakeDefault={handleMakeDefault}
                    memberId={id}
                  />
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </SimpleGrid>
      <Modal
        title={`Edit Business Member`}
        open={openModalEdit}
        footer={null}
        onCancel={handleCloseEditMember}
        width={500}
        style={{
          top: 20,
          marginBottom: openDatePicker ? "220px" : "",
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleEditMember();
          }}
        >
          <Row type="flex" justify="space-between" gutter={[25]}>
            <Col span={24}>
              <label className="formLabel">Business Name</label>
              <Input
                className="inputs"
                onChange={handleChangeEdit}
                type="text"
                name="business_name"
                placeholder="Business Name"
                value={basicEditValues.business_name}
                required
              />
            </Col>
          </Row>
          <Row type="flex" justify="space-between" gutter={[25]}>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">Business Phone</label>
              <Input
                className="inputs"
                onChange={handleChangeEdit}
                type="text"
                name="phone"
                placeholder="Phone"
                value={basicEditValues.phone}
                required
              />
            </Col>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">Business Email</label>
              <Input
                className="inputs"
                onChange={handleChangeEdit}
                type="text"
                name="email"
                placeholder="business@example.com"
                value={basicEditValues.email}
                required
              />
            </Col>
          </Row>

          <div style={{ marginTop: "15px", marginBottom: "10px", fontWeight: "bold" }}>
            Contact Person
          </div>

          <Row type="flex" justify="space-between" gutter={[25]}>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">Contact First Name</label>
              <Input
                className="inputs"
                onChange={handleChangeEdit}
                type="text"
                name="contact_person.first_name"
                placeholder="Alex"
                value={basicEditValues.contact_person?.first_name}
              />
            </Col>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">Contact Last Name</label>
              <Input
                className="inputs"
                onChange={handleChangeEdit}
                type="text"
                name="contact_person.last_name"
                placeholder="Doe"
                value={basicEditValues.contact_person?.last_name}
              />
            </Col>
          </Row>

          <Row type="flex" justify="space-between" gutter={[25]}>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">Contact Phone</label>
              <Input
                className="inputs"
                onChange={handleChangeEdit}
                type="text"
                name="contact_person.phone"
                placeholder="Phone"
                value={basicEditValues.contact_person?.phone}
              />
            </Col>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">Contact Email</label>
              <Input
                className="inputs"
                onChange={handleChangeEdit}
                type="text"
                name="contact_person.email"
                placeholder="contact@example.com"
                value={basicEditValues.contact_person?.email}
              />
            </Col>
          </Row>

          <Row type="flex" justify="space-between" gutter={[25]}>
            <Col span={24}>
              <label className="formLabel">Address</label>
              <Input
                className="inputs"
                onChange={handleChangeEdit}
                type="text"
                name="address"
                placeholder="Address"
                value={basicEditValues.address}
              />
            </Col>
          </Row>
          <Row type="flex" justify="space-between" gutter={[25]}>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">City</label>
              <Input
                className="inputs"
                onChange={handleChangeEdit}
                type="text"
                name="city"
                placeholder="City"
                value={basicEditValues.city}
              />
            </Col>
            <Col span={windowDimensions.width < 450 ? 24 : 12}>
              <label className="formLabel">State</label>
              <Input
                className="inputs"
                onChange={handleChangeEdit}
                type="text"
                name="state"
                placeholder="State"
                value={basicEditValues.state}
              />
            </Col>
          </Row>

          <div
            className="btnBox"
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "15px",
            }}
          >
            <AntdButton
              onClick={handleCloseEditMember}
              className="white-btn create-payment-request-btn"
            >
              Close
            </AntdButton>
            <AntdButton
              htmlType="submit"
              type="primary"
              loading={loadingCreate}
              className="login-btn create-payment-request-btn"
              style={{ marginLeft: "5px", minWidth: "120px" }}
            >
              {loadingCreate ? "Editing..." : "Edit"}
            </AntdButton>
          </div>
        </form>
      </Modal>
    </Box>
  );
};

export default BusinessMemberDetail;
